module.exports = __webpack_public_path__ + "9c9fc8b8b0ed4b50b85e19f495df02db.pdf";